import React, { useRef } from 'react';

// Card with a cursor-following spotlight glow. Adds .spotlight styles from index.css.
export const SpotlightCard = ({ children, className = '', as: Tag = 'div', ...props }) => {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${e.clientX - r.left}px`);
    el.style.setProperty('--my', `${e.clientY - r.top}px`);
  };
  return (
    <Tag ref={ref} onMouseMove={onMove} className={`spotlight ${className}`} {...props}>
      {children}
    </Tag>
  );
};
